import { apolloClient } from '@/services/apollo-client'
import { ADD_PINJOB, PINJOB_LIST, EDIT_PINJOB, UPDATE_PINJOB } from '@/graphql/PinJob/PinJob'

export const addPinJobAPIS = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: ADD_PINJOB,
                variables: form
            })
            resolve(res.data.addPinJob)
        } catch (e) {
            reject(e)
        }
    })
}

export const getPinJobAPIS = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: PINJOB_LIST,
                variables: form
            })
            resolve(res.data.getPinJob)
        } catch (e) {
            reject(e)
        }
    })
}

export const editPinJobAPIS = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: EDIT_PINJOB,
                variables: form
            })
            resolve(res.data.editPinJob)
        } catch (e) {
            reject(e)
        }
    })
}
export const updatePinJob = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: UPDATE_PINJOB,
                variables: form
            })
            resolve(res.data.updatePinJob)
        } catch (e) {
            reject(e)
        }
    })
}
